import { useMemo } from 'react';
import { CanvasTextNode } from '../../sweep-canvas/canvas-types';
import { TransientFunnel } from '../funnelMapCanvasTypes';
import { FunnelMapText } from '../../../types/FunnelMapText';

export const useCalculateTextNodes = ({
  textsMap,
  transientFunnel,
}: {
  textsMap?: { [id: string]: FunnelMapText };
  transientFunnel?: TransientFunnel;
}) => {
  return useMemo(() => {
    if (!textsMap && !transientFunnel) {
      return { textNodes: [] };
    }

    const textNodes = Object.entries(textsMap || {}).map(([id, textNode]) => {
      const canvasTextNode: CanvasTextNode = {
        nodeType: 'textNode',
        id: id,
        richText: textNode.richText,
        width: textNode.width,
        height: textNode.height,
        xyPosition: textNode.xyPosition,
        sectionId: textNode.sectionId,
        textScale: textNode.textScale ?? 1,
      };
      return canvasTextNode;
    });

    return { textNodes };
  }, [textsMap, transientFunnel]);
};
